export const ignoreColumnCtaClickClass = 'ignore-column-cta-click';
